import { ESnapshotExists, ENotice } from '../types';
import { NoticeType } from '../enums';

/**
 * Check if a notice is a display ad.
 */
export const isDisplay = (notice: ESnapshotExists<ENotice>): boolean => {
  return notice.data().noticeType === NoticeType.display_ad.value;
};
